(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('contact_posted')) return;

    const hash = window.location.hash.replace('#', '');

    document.querySelectorAll('.contact-form__form').forEach(function(form) {
      const idInput = form.querySelector('input[name="contact[id]"]');
      if (!idInput) return;

      if (!hash || idInput.value === hash) {
        const wrapper = form.closest('.contact-form');
        if (wrapper) {
          const success = form.querySelector('.contact-form__success');
          if (success) {
            // Move success div out of the form, into the wrapper
            wrapper.appendChild(success);
            success.style.display = 'flex';
            success.focus();
          }
        }
        form.style.display = 'none';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
